// extracted by mini-css-extract-plugin
var _1 = "ra-embedded-instagram";
var _2 = "ra-embedded-media";
var _3 = "ra-embedded-video";
export { _1 as "embeddedInstagramCls", _2 as "embeddedMediaCls", _3 as "embeddedVideoCls" }
